import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';

import SelectSitesTableCore from 'Common/SelectSitesTable';

class SelectSitesTableReduxForm extends Component {
  static propTypes = {
    loading: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
  };

  render() {
    const {
      loading,
      input: { onChange },
      meta: { touched, error, initial },
      ...rest
    } = this.props;
    return (
      <Form.Field error={touched && error ? true : false}>
        <SelectSitesTableCore
          onChange={onChange}
          loading={loading}
          initialSelectedSiteIds={initial}
          {...rest}
        />
        {touched && error && <span>{error}</span>}
      </Form.Field>
    );
  }
}

export { SelectSitesTableReduxForm };

export default SelectSitesTableReduxForm;



// WEBPACK FOOTER //
// ./src/common/SelectSitesTableReduxForm.js